import React, { useState, useEffect, useRef } from 'react';
import { Bar } from 'react-chartjs-2';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import MemberTaskDetails from './Task/MemberTaskDetails';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);


const HomeVisitTask = ({ token }) => {
  const [taskData, setTaskData] = useState(null);
  const [taskChartData, setTaskChartData] = useState(null);
  const [startDate, setStartDate] = useState('2024-09-17');
  const [endDate, setEndDate] = useState('2025-10-17');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [dateFilterActive, setDateFilterActive] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const navigate = useNavigate();
  const chartRef = useRef();
  const [searchParams] = useSearchParams();

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5199';

  // Check if we should show details page based on URL params
  const userId = searchParams.get('userId');
  const status = searchParams.get('Status');
  
  // If we have userId and Status in URL, show details page
  useEffect(() => {
    if (userId && status) {
      setShowDetails(true);
    } else {
      setShowDetails(false);
    }
  }, [userId, status]);

  // Declare urlParams once for reuse in both effects
  const urlParams = new URLSearchParams(window.location.search);

  useEffect(() => {
    const fetchInitialTaskStatus = async () => {
      try {
        setLoading(true);
        setError(null);
        // Hardcoded API parameter code for reference:
        // const params = new URLSearchParams({
        //   CaseManagerOrQueueId: 'patilsmi',
        //   DueDateFrom: '2024-09-17T00:00:00',
        //   DueDateTo: '2025-10-17T00:00:00',
        //   UserType: 'PowerUser',
        //   CardGuid: 'f2d48a42-895d-41aa-8ad1-1b769b3d7bd2',
        //   MemberId: '117041388'
        // }).toString();
        // const response = await fetch(`${API_BASE_URL}/api/Task/status?${params}`);
        // if (!response.ok) {
        //   throw new Error('Failed to fetch Home Visit Task data');
        // }
        // const data = await response.json();
        // const chartResult = data && Array.isArray(data.chartResult) ? data.chartResult : [];
        // setTaskData(chartResult);
        // const chartData = processTaskData(chartResult);
        // setTaskChartData(chartData);

        // Dynamic API parameter code:
  let caseManagerOrQueueId = urlParams.get('externalUserId');
  let startDateParam = urlParams.get('startDate');
  let endDateParam = urlParams.get('endDate');
        let userType = urlParams.get('userType') ;
        let cardGuid = urlParams.get('cardGuid') ;
        let memberId = urlParams.get('memberId') ;

        function toISODate(dateStr) {
          if (!dateStr) return dateStr;
          const mmddyyyy = /^(\d{2})\/(\d{2})\/(\d{4})$/;
          const match = decodeURIComponent(dateStr).match(mmddyyyy);
          if (match) {
            const [, mm, dd, yyyy] = match;
            return `${yyyy}-${mm}-${dd}T00:00:00`;
          }
          return dateStr;
        }
  startDateParam = toISODate(startDateParam);
  endDateParam = toISODate(endDateParam);

        const params = new URLSearchParams({
          CaseManagerOrQueueId: caseManagerOrQueueId,
          StartDate: startDateParam,
          EndDate: endDateParam,
          UserType: userType,
          CardGuid: cardGuid,
          MemberId: memberId
        }).toString();
        const response = await fetch(`${API_BASE_URL}/api/Task/status?${params}`);
        if (!response.ok) {
          throw new Error('Failed to fetch Home Visit Task data');
        }
  const data = await response.json();
  const chartResult = data && Array.isArray(data.taskStatusList) ? data.taskStatusList : [];
  setTaskData(chartResult);
  const chartData = processTaskData(chartResult);
  setTaskChartData(chartData);
      } catch (err) {
        setTaskData(null);
        setTaskChartData(null);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchInitialTaskStatus();
    // eslint-disable-next-line
  }, [token]);

  useEffect(() => {
    if (!dateFilterActive) return;
    const fetchTaskStatusDatewise = async () => {
      try {
        setLoading(true);
        setError(null);
  // Get parameters from query string
  const urlParams = new URLSearchParams(window.location.search);
        // Hardcoded API parameter code for reference
        // const params = new URLSearchParams({
        //   CaseManagerOrQueueId: 'patilsmi',
  //   DueDateFrom: `${startDate}T00:00:00`,
        //   DueDateTo: `${taskDateTo}T00:00:00`,
        //   UserType: 'PowerUser',
        //   CardGuid: 'f2d48a42-895d-41aa-8ad1-1b769b3d7bd2'
        // }).toString();
        // const response = await fetch(`${API_BASE_URL}/api/Task/datewise-filter?${params}`);
        // if (!response.ok) {
        //   throw new Error('Failed to fetch Home Visit Task data');
        // }
        // const data = await response.json();
        // setTaskData(Array.isArray(data) ? data : []);
        // const chartData = processTaskData(Array.isArray(data) ? data : []);
        // setTaskChartData(chartData);

        // Dynamic API parameter code:
  let caseManagerOrQueueId = urlParams.get('externalUserId');
  let startDateParam = urlParams.get('startDate');
  let endDateParam = urlParams.get('endDate');
        let userType = urlParams.get('userType');
        let cardGuid = urlParams.get('cardGuid');

        function toISODate(dateStr) {
          if (!dateStr) return dateStr;
          const mmddyyyy = /^(\d{2})\/(\d{2})\/(\d{4})$/;
          const match = decodeURIComponent(dateStr).match(mmddyyyy);
          if (match) {
            const [, mm, dd, yyyy] = match;
            return `${yyyy}-${mm}-${dd}T00:00:00`;
          }
          return dateStr;
        }
  startDateParam = toISODate(startDateParam);
  endDateParam = toISODate(endDateParam);

        const params = new URLSearchParams({
          CaseManagerOrQueueId: caseManagerOrQueueId,
          StartDate: startDateParam,
          EndDate: endDateParam,
          UserType: userType,
          CardGuid: cardGuid
        }).toString();
        const response = await fetch(`${API_BASE_URL}/api/Task/datewise-filter?${params}`);
        if (!response.ok) {
          throw new Error('Failed to fetch Home Visit Task data');
        }
        const data = await response.json();
        setTaskData(Array.isArray(data) ? data : []);
        const chartData = processTaskData(Array.isArray(data) ? data : []);
        setTaskChartData(chartData);
      } catch (err) {
        setTaskData(null);
        setTaskChartData(null);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchTaskStatusDatewise();
    // eslint-disable-next-line
  }, [token, startDate, endDate, dateFilterActive]);

  const processTaskData = (taskStatusList) => {
    if (!taskStatusList || taskStatusList.length === 0) {
      return {
        labels: [],
        datasets: [
          {
            label: 'Complete',
            backgroundColor: '#4eaa4e',
            maxBarThickness: 60,
            data: []
          },
          {
            label: 'Over Due',
            backgroundColor: '#eb4c44',
            maxBarThickness: 60,
            data: []
          },
          {
            label: 'Future',
            backgroundColor: '#eab00a',
            maxBarThickness: 60,
            data: []
          }
        ]
      };
    }
    const uniqueLabels = [];
    const labelSet = new Set();
    taskStatusList.forEach(item => {
      if (item.createdBy && item.user_id) {
        const label = `${item.createdBy}(${item.user_id})`;
        if (!labelSet.has(label)) {
          uniqueLabels.push(label);
          labelSet.add(label);
        }
      }
    });
    // Always show bars for all users, count actual tasks not statusCount
    const getStatusCount = (status, label) => {
      // Find all tasks for this user and status
      const filtered = taskStatusList.filter(
        x => x.status === status && `${x.createdBy}(${x.user_id})` === label
      );
      // Count the number of actual task records (length of array)
      return filtered.length;
    };
    const completeList = uniqueLabels.map(label => getStatusCount('Complete', label));
    const overdueList = uniqueLabels.map(label => getStatusCount('Over Due', label));
    const futureList = uniqueLabels.map(label => getStatusCount('Future', label));
    return {
      labels: uniqueLabels,
      datasets: [
        {
          label: 'Complete',
          backgroundColor: '#4eaa4e',
          maxBarThickness: 60,
          data: completeList
        },
        {
          label: 'Over Due',
          backgroundColor: '#eb4c44',
          maxBarThickness: 60,
          data: overdueList
        },
        {
          label: 'Future',
          backgroundColor: '#eab00a',
          maxBarThickness: 60,
          data: futureList
        }
      ]
    };
  };

  const handleTaskChartClick = (event, elements) => {
    if (elements.length > 0) {
      const element = elements[0];
      const datasetLabel = taskChartData.datasets[element.datasetIndex].label;
      const status = taskChartData.labels[element.index];
      const userId = status.split('(')[1].split(')')[0];
      
      // Get current URL parameters to pass them along
      const urlParams = new URLSearchParams(window.location.search);
      
      // Get all the original parameters
      const externalUserId = urlParams.get('externalUserId');
      const userType = urlParams.get('userType');
      const startDate = urlParams.get('startDate');
      const endDate = urlParams.get('endDate');
      const loggedUserName = status.split('(')[0]; // Extract user name from label
      
      // Format dates to include time part like .NET version
      const formatDateWithTime = (dateStr) => {
        if (!dateStr) return dateStr;
        // If date already has time, return as is
        if (dateStr.includes('00:00:00')) return dateStr;
        // Add time part to match .NET format, but URL encode properly
        return `${dateStr} 00:00:00`;
      };
      
      // Build URL in the exact order as .NET version
      const searchParams = new URLSearchParams();
      if (externalUserId) searchParams.set('externalUserId', externalUserId);
      if (userType) searchParams.set('userType', userType);
      if (startDate) searchParams.set('startDate', formatDateWithTime(startDate));
      if (endDate) searchParams.set('endDate', formatDateWithTime(endDate));
      searchParams.set('userId', userId);
      searchParams.set('Status', datasetLabel);
      if (loggedUserName) searchParams.set('loggedUserName', loggedUserName);
      
      console.log('Navigating with URL params:', searchParams.toString());
      
      // Update URL without navigation - this will trigger the useEffect above
      window.history.pushState({}, '', `?${searchParams.toString()}`);
      setShowDetails(true);
    }
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    onClick: handleTaskChartClick,
    plugins: {
      legend: {
        display: false
      },
      title: {
        display: false
      }
    },
    scales: {
      x: {
        maxBarThickness: 60,
        stacked: false,
        grid: {
          display: true,
          color: '#e0e0e0'
        },
        ticks: {
          font: {
            size: 9
          },
          maxRotation: 45,
          minRotation: 0,
          autoSkip: false
        }
      },
      y: {
        stacked: false,
        beginAtZero: true,
        grid: {
          display: true,
          color: '#e0e0e0'
        },
        ticks: {
          stepSize: 1,
          font: {
            size: 11
          }
        }
      }
    }
  };

  return (
    <div className="home-visit-task-page">
      {showDetails ? (
        <MemberTaskDetails />
      ) : (
        <div className="card" style={{ width: '1200px', margin: '0 auto' }}>
          <div className="card-body">
          
          
            <div className="mb-3 text-center">
              <span className="me-3">
                <span style={{display: 'inline-block', width: '30px', height: '16px', backgroundColor: '#4eaa4e', marginRight: '5px'}}></span>
                Complete
              </span>
              <span className="me-3">
                <span style={{display: 'inline-block', width: '30px', height: '16px', backgroundColor: '#eb4c44', marginRight: '5px'}}></span>
                Over Due
              </span>
              <span className="me-3">
                <span style={{display: 'inline-block', width: '30px', height: '16px', backgroundColor: '#eab00a', marginRight: '5px'}}></span>
                Future
              </span>
            </div>
            <div className="mt-3" style={{ height: '250px' }}>
              {taskChartData ? (
                <Bar ref={chartRef} data={taskChartData} options={chartOptions} />
              ) : (
                <div className="d-flex align-items-center justify-content-center h-100 border rounded">
                  <div className="text-center text-muted">
                    <div>No task data available</div>
                   
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HomeVisitTask;
